import { useState, useEffect } from "react"
import { enquireScreen } from 'enquire-js'
import { HeaderNavDataSource } from "../components/Home/data.source"
import PreFooter from "../components/Home/PreFooter"
import Header from "../components/Home/Header"
import Footer from "../components/Home/Footer"
import { useParams } from "react-router-dom"
import PostDetail from "../components/Home/PostDetail"
import DemoModal from "../components/Home/DemoModal"
import { postAnalyticClick } from "../services/demo"

let isThisMobile : boolean
enquireScreen((b : boolean) => {
  isThisMobile = b
})

const BlogDetail = () => {
  let { slug } = useParams<any>();

  const [demoModalOpen, isDemoModalOpen] = useState(false)

  const [isMobile, setIsMobile] = useState(isThisMobile)
  const [show, isShown] = useState(false)
  const [attachment, setAttachment] = useState<number>()

  useEffect(() => {
    enquireScreen((b : boolean) => {
      setIsMobile(!!b)
    })
    
    if (window.location.port) {
      setTimeout(() => {
        isShown(true)
      }, 500)
    } else {
      isShown(true)
    }
  }, [isMobile, show])

  const showDemoModal = async () => {
    isDemoModalOpen(!demoModalOpen)
    await postAnalyticClick('demo_clicks')
  }

  const downloadEbook = (attachmentId: number) => {
    setAttachment(attachmentId)
    isDemoModalOpen(!demoModalOpen)
  }

  const children = [
    <Header
      dataSource={HeaderNavDataSource(showDemoModal)}
      isMobile={isMobile}
      key="Header"
    />,
    <PostDetail
      isMobile={isMobile}
      slug={slug}
      downloadEbook={downloadEbook}
      key="PostDetail"
    />,
    <PreFooter
      isMobile={isMobile}
      key="Pre-Footer"
    />,
    <Footer
      dataSource={[]}
      isMobile={isMobile}
      key="Footer"
    />,
  ]

  return (
    <div
      className="templates-wrapper"
    >
      {show && children}
      <DemoModal
        modalOpen={demoModalOpen}
        isModalOpen={isDemoModalOpen}
        attachment={attachment}
      />
    </div>
  )
}

export default BlogDetail